module.exports = __webpack_public_path__ + "assets/img/2404.53c78cc5.svg";